import {lgSetup, validateInSetup} from "../../backend/LgSetup";

function assignParam(key, ret, params) {
    ret[key] = params[key];
}

export function getValidLookupObject(lookup, key, ret, params) {
    assignParam(key, ret, params)
    validateInSetup(lookup, ret[key])
    return lgSetup[lookup][ret[key]]
}
